export default {
  'welcome': 'Sign in',
  'Password': 'Password',
  'Create account': 'Registration',
  'Log In': 'Log In',
  'agreement_ckeck.part': 'I accept ',
  'Terms of Use': 'License Agreement',
  'Create New Account': 'Sign Up',
  'Already joined?': 'Already joined?',
  'Sign Up': 'Sign Up',
  'Country': 'Country',
  'Phone Number': 'Phone Number',
  'Pre.Step1.Dep.Text': '',
  'Pre.Step2.Dep.Text_1': 'Please, make a transfer using',
  'Pre.Step2.Dep.Text_2': 'this instruction',
  'Pre.Step2.Dep.Text_3': 'and fill the form below',
  'Pre.Dep.Confirm.Text': 'Please double-check your transfer and press Confirm.',
  'Select Bank for Deposit': 'Select Bank for Deposit',
  'Please, select bank form list by clicking on its logo': 'Please, select bank form list by clicking on its logo',
  'Create Deposit Request': 'Create Deposit Request',
  'My Balance:': 'My Balance:',
  'My Profile': 'My Profile',
  'menu.dashboard': 'Dashboard',
  'menu.deposits': 'Deposits',
  'menu.withdrawals': 'Withdrawals',
  'Logout': 'Logout',
  'commission': 'Commission',
  'transfer.date': 'Transfer Date',
  'screenshot': 'Screenshot',
  'todays.rate.tip': '- Using today\'s exchange rate (1&nbsp;USD&nbsp;=&nbsp;{rate})',
  'deposit.percents.tip': '8%, but not less than 20 ILS',
  'deposit.value': 'Deposit Value',
  'deposit': 'Deposit',
  'withdraw': 'Withdraw',
  'your.balance': 'Your Balance',
  'success': 'SUCCESS',
  'error': 'Error',
  'id.number': 'ID (TEUDAT ZEHUT)',
  'tab.dashboard': 'Dashboard',
  'tab.last.deposits': 'Last Deposits',
  'tab.last.withdrawals': 'Last Withdrawals',
  'tab.last.operations': 'Last Operations',
  'tab.support': 'Support',
  'Team Members': 'Team Members',
  'New Messages': 'New Messages',
  'deposit.amount': 'Deposit Amount',
  'code': 'Code',
  'Deposit in USD': 'Deposit in USD',
  'Final rate will be fixed when your request will be confirmed.': 'Final rate will be fixed when your request will be confirmed.',
  'remove': 'Remove',
  'comment': 'Comment',
  'messages': 'Messages',
  'deposit.note': 'Your MIKIPAY account will be credited immediately after we receive your transfer, this will happen no later than ',
  'confirm.request': 'Confirm your request',
  'bank': 'Bank',
  'request.sent': 'Request sent! Thank you for using MIKIPAY.',
  'receive.sms.notification': 'You’ll receive SMS notification.',
  'menu.helpdesk': 'Support',
  'menu.profile': 'Your Profile',
  'menu.last.operations': 'Last Operations',
  'please.signin': 'Please Sign In',
  'OR': 'OR',
  'Deposit via Exchange Office': 'Deposit via Exchange Office',
  'Close': 'Close',
  'Paused untill ': 'Paused untill ',
  'New Deposit': 'New Deposit',
  'Deposit via Bank': 'Deposit via Bank',
  'Active Deposits': 'Active Deposits',
  'Auth': 'Auth',
  'Login': 'Login',
  'Signup': 'Signup',
  'Reset': 'Reset'
}



// WEBPACK FOOTER //
// ./src/store/locale/en.js